import React, { useState } from 'react';

import PagePanel from 'src/components/PagePanel';
import PageHeader from 'src/components/PageHeader';
import { useResetPageParam } from 'src/hooks/useResetPageParam';

import AllWalletsTab from './AllWalletsTab';
import WhitelistTab from './WhitelistTab';
import InternalWalletsTab from './InternalWalletsTab';
import { WalletTab, WalletTabs } from './styled';

type WalletsView = 'all' | 'whitelist' | 'internal';

const Wallets = () => {
  const [activeTab, setActiveTab] = useState<WalletsView>('all');
  const resetPageParam = useResetPageParam();
  const [totalCount, setTotalCount] = useState<number | null>(null);

  const title =
    totalCount == null ? 'Wallets' : `Wallets (${totalCount})`;

  return (
    <PagePanel>
      <PageHeader title={title} hideSearch />
      <WalletTabs>
        <WalletTab
          type="button"
          $active={activeTab === 'all'}
          onClick={() => {
            setActiveTab('all');
            setTotalCount(null);
            resetPageParam();
          }}
        >
          All Wallets
        </WalletTab>
        <WalletTab
          type="button"
          $active={activeTab === 'whitelist'}
          onClick={() => {
            setActiveTab('whitelist');
            setTotalCount(null);
            resetPageParam();
          }}
        >
          Whitelist
        </WalletTab>
        <WalletTab
          type="button"
          $active={activeTab === 'internal'}
          onClick={() => {
            setActiveTab('internal');
            setTotalCount(null);
            resetPageParam();
          }}
        >
          Treasury
        </WalletTab>
      </WalletTabs>

      {activeTab === 'all' ? (
        <AllWalletsTab onTotalChange={setTotalCount} />
      ) : activeTab === 'whitelist' ? (
        <WhitelistTab onTotalChange={setTotalCount} />
      ) : (
        <InternalWalletsTab onTotalChange={setTotalCount} />
      )}
    </PagePanel>
  );
};

export default Wallets;
